import React, { useState, useEffect } from 'react';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useMediaQuery } from '@mui/material';
import { getMerchandiseByReference, deleteMerchandise } from '../../../services/api';
import DetalhesModal from '../../modals/detalhesmerchandise'; // Modal de detalhes
import ConfirmModal from '../../modals/confirmx'; // Modal de confirmação

const VerArtigosPorReferencia = () => {
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showDetalhesModal, setShowDetalhesModal] = useState(false);
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [productToDelete, setProductToDelete] = useState(null);
    const isMobile = useMediaQuery('(max-width:800px)');

    useEffect(() => {
        const fetchArticles = async () => {
            setLoading(true);
            try {
                const response = await getMerchandiseByReference();
                setArticles(response.data);
            } catch (error) {
                console.error("Erro ao buscar artigos por referência", error);
            }
            setLoading(false);
        };

        fetchArticles();
    }, []);

    // Acessa diretamente o current_quantity retornado pelo serializer
    const stockBodyTemplate = (rowData) => rowData.current_quantity || 0;

    // Ações: botão para visualizar detalhes e outro para excluir o artigo
    const actionBodyTemplate = (rowData) => {
        return (
            <div>
                <Button 
                    icon="pi pi-info-circle" 
                    className="p-button-rounded p-button-text" 
                    onClick={() => handleViewDetails(rowData)}
                />
                <Button 
                    icon="pi pi-trash" 
                    className="p-button-rounded p-button-text p-button-danger" 
                    onClick={() => handleDeleteClick(rowData)}
                />
            </div>
        );
    };

    const handleViewDetails = (rowData) => {
        setSelectedProduct(rowData);
        setShowDetalhesModal(true);
    };

    const handleDeleteClick = (rowData) => {
        setProductToDelete(rowData);
        setShowConfirmDelete(true);
    };

    const confirmDelete = async () => {
        try {
            await deleteMerchandise(productToDelete.id);
            setArticles(prev => prev.filter(product => product.id !== productToDelete.id));
        } catch (error) {
            console.error("Erro ao eliminar produto", error);
        } finally {
            setShowConfirmDelete(false);
            setProductToDelete(null);
        }
    };

    const header = (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span className="p-input-icon-right">
                <InputText 
                    type="search" 
                    onInput={(e) => setGlobalFilter(e.target.value)} 
                    placeholder="Pesquisar por referência" 
                    size="50" 
                />
                <i className="pi pi-search" style={{ right: '10px' }} />
            </span>
        </div>
    );

    return (
        <Card title="Artigos por Referência">
            <DataTable 
                value={articles} 
                paginator 
                rows={isMobile ? 5 : 10} 
                header={header} 
                globalFilter={globalFilter} 
                loading={loading}
                responsiveLayout="scroll"
                emptyMessage="Nenhum artigo encontrado."
            >
                <Column field="name" header="Nome" sortable />
                <Column field="reference" header="Referência" sortable />
                <Column body={stockBodyTemplate} header="Stock" sortable />
                <Column body={actionBodyTemplate} header="Ações" exportable={false} style={{ minWidth: '8rem' }} />
            </DataTable>

            {/* Modal de detalhes */}
            <DetalhesModal 
                visible={showDetalhesModal} 
                onHide={() => setShowDetalhesModal(false)} 
                merchandise={selectedProduct}
            />

            {/* Modal de confirmação para exclusão */}
            <ConfirmModal 
                visible={showConfirmDelete}
                message={`Tem certeza que deseja eliminar o produto ${productToDelete ? productToDelete.name : ''}?`}
                onConfirm={confirmDelete}
                onCancel={() => {
                    setShowConfirmDelete(false);
                    setProductToDelete(null);
                }}
            />
        </Card>
    );
};

export default VerArtigosPorReferencia;
